<template>
  <div class="editor-wrapper">
    <div v-if="editor === 'background'">
      <background-editor></background-editor>
    </div>
    <div v-else-if="editor === 'buttons'">
      <buttons-editor></buttons-editor>
    </div>
    <div v-else-if="editor === 'description'">
      <caption-editor></caption-editor>
    </div>
    <div v-else-if="editor === 'leds'">
      <bargraph-editor></bargraph-editor>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import BackgroundEditor from "../../views/editors/BackgroundEditor.vue";
import ButtonsEditor from "../../views/editors/ButtonsEditor.vue";
import CaptionEditor from "../../views/editors/CaptionEditor.vue";
import BargraphEditor from "../../views/editors/BargraphEditor.vue";

export default {
  components: {
    BackgroundEditor,
    ButtonsEditor,
    CaptionEditor,
    BargraphEditor,
  },
  setup() {
    const store = useStore();
    const editor = computed(() => store.getters.currentEditor);
    const lastColor = computed(() => store.getters.lastColor);

    return {
      editor,
      lastColor,
    };
  },
};
</script>

<style lang="scss">
.editor-wrapper {
  // position: relative;
  margin-top: 10px;
  box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
  -webkit-box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
  -moz-box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
}
.editor-title {
  border-bottom: 2px solid #ffde00;
  background-color: #f1f1f1;
}
.editor-title > h4 {
  padding: 10px;
  height: 50px;
  line-height: 30px;
  margin-bottom: 0;
}
.color-picker,
.element {
  height: 40px;
  border-bottom: 1px solid #ffde00;
}
.expand {
  cursor: pointer;
}

.color-picker-label,
.label {
  padding-left: 35px;
}
h2 {
  font-size: 18px;
  line-height: 34px;
  font-weight: 500;
  letter-spacing: 1px;
  display: block;
  margin: 0;
  color: #6c6c6a;
}

.content-expand {
  color: rgba(48, 69, 92, 0.8);
  font-size: 15px;
  line-height: 26px;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  max-height: 800px;
  opacity: 1;
  transform: translate(0, 0);
  // margin-top: 14px;
  // margin-bottom: 20px;
  z-index: 2;
}
ul {
  list-style: none;
  perspective: 900;
  padding: 0 20px;
  margin: 0;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(255, 255, 255, 0.19);
}
.editor-element {
  position: relative;
  padding: 0;
  margin: 0;
  padding-bottom: 5px;
  padding-top: 5px;
  border-top: 1px dotted #ffde00;
}
.topic-separator {
  position: relative;
  padding: 0;
  margin: 0;
  padding-bottom: 5px;
  padding-top: 5px;
  border-top: 2px dotted #ffde00;
}

.editor-element:nth-child(1) {
  border: none;
}
.editor-element:nth-of-type(1) {
  animation-delay: 0.5s;
}
.editor-element:nth-of-type(2) {
  animation-delay: 0.75s;
}
.editor-element:nth-of-type(3) {
  animation-delay: 1s;
}
.editor-element:last-of-type {
  padding-bottom: 10px;
}
.editor-element:only-child {
  padding-bottom: 0;
}
.editor-element:only-child > .content-expand:last-child {
  padding-bottom: 10px;
}

.editor-element .arrow {
  position: absolute;
  transform: translate(-6px, 0);
  margin-top: 16px;
  right: 0;
}
.editor-element .fas {
  color: #f6483b;
  font-size: 15px;
  margin-right: 10px;
}
.editor-element .arrow:before,
.editor-element .arrow:after {
  content: "";
  position: absolute;
  background-color: #ffde00;
  width: 3px;
  height: 9px;
}
.editor-element .arrow:before {
  transform: translate(-2px, 0) rotate(45deg);
}
.editor-element .arrow:after {
  transform: translate(2px, 0) rotate(-45deg);
}
.editor-element input[type="checkbox"] {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  top: 0;
  left: 0;
}
.editor-element input[type="checkbox"]:checked ~ .content-expand,
.editor-element input[type="checkbox"]:checked ~ p {
  margin-top: 0;
  max-height: 0;
  opacity: 0;
  transform: translate(0, 50%);
}
.editor-element input[type="checkbox"]:checked ~ .arrow:before {
  transform: translate(2px, 0) rotate(45deg);
}
.editor-element input[type="checkbox"]:checked ~ .arrow:after {
  transform: translate(-2px, 0) rotate(-45deg);
}
.transition,
.content-expand,
.editor-element .arrow:before,
.editor-element .arrow:after {
  transition: all 0.25s ease-in-out;
}
.no-select,
h2 {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
}
.color-picker {
  background-color: blue;
  height: 25px;
  width: 50px;
  padding: 5px;
  margin: 5px;
  border: 1px solid #eee;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}
.color-picker-container {
  border: 1px solid #eee;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
